<template>
  <div v-loading="loading" class="deptMerge">
    <div class="_title">
      <p class="_title_info">部门合并迁移</p>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="right"
      class="_jbxxForm"
      label-width="230px"
    >
      <el-form-item label="源部门（被合并，合并后删除）：" prop="sourceDeptId">
        <el-cascader
          v-model="form.sourceDeptId"
          :options="deptTree"
          :props="cascaderProps"
          :show-all-levels="false"
          filterable
          clearable
          placeholder="输入部门名称可快速搜索"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="目标部门（承接方）：" prop="targetDeptId">
        <el-cascader
          v-model="form.targetDeptId"
          :options="deptTree"
          :props="cascaderProps"
          :show-all-levels="false"
          filterable
          clearable
          placeholder="输入部门名称可快速搜索"
          style="width: 100%"
        />
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button v-preventReClick type="primary" @click="submit"> 确 认 合 并 </el-button>
      </div>
      <div>
        <p style="color:red;margin-left:120px;margin-top:60px">
          提示：合并会把源部门辖区的单位、仓库的行政区划迁到目标部门，并在备注里记录"由源部门合并到目标部门"；
          源部门、源区划和部门下的用户会被删除（逻辑删除，不可撤销）。
        </p>
        <p style="color:red;margin-left:120px;margin-top:10px">
          源区划下还有待审批流程、子部门或其他部门时会拒绝执行，需要先处理完。
        </p>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDeptTree } from '@/assets/js/yhgl.js'
import { deptMerge } from '@/assets/js/deptMerge.js'

export default {
  name: 'DeptMerge',
  data() {
    return {
      loading: false,
      deptTree: [],
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children',
        emitPath: false,
        checkStrictly: true
      },
      form: {
        sourceDeptId: '',
        targetDeptId: ''
      },
      rules: {
        sourceDeptId: [{ required: true, message: '请选择源部门', trigger: 'change' }],
        targetDeptId: [{ required: true, message: '请选择目标部门', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadDeptTree()
  },
  methods: {
    loadDeptTree() {
      getDeptTree().then((e) => {
        if (e.data && e.data.data) {
          this.deptTree = e.data.data
        }
      })
    },
    reset() {
      this.form = { sourceDeptId: '', targetDeptId: '' }
      this.$refs['form'].clearValidate()
    },
    submit() {
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          return
        }
        if (this.form.sourceDeptId === this.form.targetDeptId) {
          this.$message.error('源部门和目标部门不能相同')
          return
        }
        this.$confirm(
          '确定执行部门合并吗？合并后源部门、源区划及其下的用户会被删除，操作不可撤销！',
          '提示',
          {
            confirmButtonText: '确定合并',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.loading = true
            deptMerge(this.form)
              .then((e) => {
                this.loading = false
                const res = e.data || {}
                if (res.code === '000000') {
                  const d = res.data || {}
                  this.$alert(
                    '合并完成：<br/>' +
                      '源部门：' + (d.sourceDeptName || '') + '（区划：' + (d.sourceXzqhName || '') + '）<br/>' +
                      '目标部门：' + (d.targetDeptName || '') + '（区划：' + (d.targetXzqhName || '') + '）<br/>' +
                      '迁移单位 ' + d.dwCount + ' 个，仓库 ' + d.dwCkCount + ' 个<br/>' +
                      '删除用户 ' + d.userCount + ' 个：' + ((d.deletedUsers || []).join('、') || '无') + '<br/>' +
                      '备注：' + (d.note || ''),
                    '合并结果',
                    { dangerouslyUseHTMLString: true, confirmButtonText: '知道了' }
                  )
                  this.reset()
                } else {
                  this.$message.error(res.mesg || '合并失败')
                }
              })
              .catch(() => {
                this.loading = false
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.deptMerge {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 40px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 80px auto 0px auto;
    width: 60%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0px auto;
    width: 40%;
  }
}
</style>
